import { render, staticRenderFns } from "./NOTFOUND.vue?vue&type=template&id=417d2630"
import script from "./NOTFOUND.vue?vue&type=script&lang=js"
export * from "./NOTFOUND.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports